import type { SVGProps } from 'react';
const SvgSouthWest = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#south_west_svg__a)">
      <path
        fill="currentColor"
        d="M15 19v-2H8.41L20 5.41 18.59 4 7 15.59V9H5v10h10Z"
      />
    </g>
    <defs>
      <clipPath id="south_west_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSouthWest;
